export default __webpack_public_path__ + "assets/images/example-policy-system-connection-a332b968bdabf95712d69537f78fdd5b.png";